export default function formatProp65Warning(content) {
  return content.replace('&58;', ':')
}
